<template>
  <!-- Нет метки — ничего не рисуется (комментарий-заглушка): вёрстка экрана не меняется. -->
  <span v-if="visible" class="agent-marker" data-testid="agent-marker">
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-icon v-bind="attrs" small :color="iconColor" :aria-label="$t('agent_marker.label')" v-on="on">
          mdi-robot-outline
        </v-icon>
      </template>
      <span data-testid="agent-marker-tooltip">{{ tooltip }}</span>
    </v-tooltip>
  </span>
</template>

<script>
// FT-184 REQ-12 / REQ-16 / write-layer §10: метка «через агента» у записи, которую изменил AI-агент.
//
// Два источника:
//   * recordType + recordId — метка из ответа экрана (ключ agent_marks), который экран кладёт в общее
//     хранилище (agentMarkerLoader.prime); компонент только читает его, своих запросов нет — правило
//     «одна страница — один запрос». Подсказка — инструмент и время;
//   * present — факт уже известен из самих данных (сообщение CRM с metadata.source = "mcp"),
//     подсказка без подробностей.
// Метка — только иконка робота, надпись — в подсказке (USER 2026-10-06); в тёмной теме — светлый
// оттенок, deep-purple на тёмном фоне не виден.
// Метки показываются только штатным ролям (как и сервер отдаёт их только им) — у агента, партнёра и
// гостя метки по связи нет.
import moment from "moment";
import { momentLocaleFor } from "@/utils/localeInfra";
import markerLoader from "./agentMarkerLoader";

export default {
  name: "AgentMarker",
  props: {
    recordType: { type: String, default: null },
    recordId: { type: [Number, String], default: null },
    present: { type: Boolean, default: false },
    color: { type: String, default: null },
  },
  computed: {
    canLoad() {
      const getters = this.$store && this.$store.getters;
      return !this.present && !!this.recordType && !!this.recordId && !!(getters && getters.isStaff);
    },
    marker() {
      return this.canLoad ? markerLoader.markerFor(this.recordType, this.recordId) : null;
    },
    iconColor() {
      if (this.color) return this.color;
      return this.$vuetify.theme.dark ? "deep-purple lighten-2" : "deep-purple";
    },
    visible() {
      return this.present || !!this.marker;
    },
    tooltip() {
      if (!this.marker) return this.$t("agent_marker.tooltip_source");
      return this.$t("agent_marker.tooltip", {
        tool: this.marker.tool,
        // Дата и время по локали интерфейса (как списки платежей: "lll"), без смены глобальной локали moment.
        time: moment(this.marker.created_at).locale(momentLocaleFor(this.$i18n && this.$i18n.locale)).format("lll"),
      });
    },
  },
};
</script>

<style scoped>
.agent-marker {
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
  vertical-align: middle;
}
</style>
